import { createContext, useState } from 'react'

export const DarkThemeContext = createContext()

const DarkTheme = ({ children }) => {
  const [darkToggle, setDarkToggle] = useState(false)
  return (
    <DarkThemeContext.Provider value={{ darkToggle, setDarkToggle }}>
      {children}
    </DarkThemeContext.Provider>
  )
}

export default DarkTheme
